import React from 'react';
import GaugeIndicador, { CorGauge } from './GaugeIndicador';

export interface IndicadorCardProps {
  id: string;
  titulo: string;
  valor: string | number;
  detalhe?: string;
  cor?: CorGauge;
  ativo?: boolean;
  onClick?: (id: string) => void;
  /** Quando presente, o valor é exibido como velocímetro ("X de Y") em vez de número solto. */
  gauge?: { valor: number; maximo: number; sufixo?: string; casasDecimais?: number };
}

const IndicadorCard: React.FC<IndicadorCardProps> = ({ id, titulo, valor, detalhe, cor = 'primary', ativo, onClick, gauge }) => (
  <button
    type='button'
    className={`mc-indicador mc-indicador--${cor}${ativo ? ' mc-indicador--ativo' : ''}${onClick ? '' : ' mc-indicador--estatico'}${gauge ? ' mc-indicador--gauge' : ''}`}
    onClick={onClick ? () => onClick(id) : undefined}
    disabled={!onClick}
  >
    <span>{titulo}</span>
    {gauge
      ? <GaugeIndicador valor={gauge.valor} maximo={gauge.maximo} cor={cor} sufixo={gauge.sufixo} casasDecimais={gauge.casasDecimais} />
      : <strong>{valor}</strong>}
    {detalhe && <small>{detalhe}</small>}
  </button>
);

export default IndicadorCard;
